class DialogTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button[type="button"]');
    this.button.addEventListener("click", () => this.handleClick());
  }

  handleClick() {
    const dialogId = this.button.getAttribute("aria-controls");
    const dialog = document.getElementById(dialogId);
    if (!dialog) return;
    dialog.showModal();
  }
}

customElements.define("dialog-trigger", DialogTrigger);
